/** @param {{ address?: object } | null | undefined} shop */
export function getShopLatLng(shop) {
  if (!shop?.address) return null;
  const a = shop.address;
  if (typeof a.latitude === 'number' && typeof a.longitude === 'number') {
    return { lat: a.latitude, lng: a.longitude };
  }
  const coords = a.location?.coordinates;
  if (Array.isArray(coords) && coords.length >= 2) {
    const [lng, lat] = coords;
    if (typeof lat === 'number' && typeof lng === 'number') {
      return { lat, lng };
    }
  }
  return null;
}

/**
 * True when the Geolocation API returned usable lat/lng (not NaN, in range, not 0,0).
 * Browsers may still call success with 0,0 or garbage when the device cannot get a fix
 * even if site permission is granted.
 * @param {GeolocationCoordinates} coords
 */
export function isPlausibleGeolocation(coords) {
  if (!coords) return false;
  const lat = coords.latitude;
  const lng = coords.longitude;
  if (typeof lat !== 'number' || typeof lng !== 'number') return false;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return false;
  if (lat === 0 && lng === 0) return false;
  return true;
}

/** Haversine distance in km */
export function distanceKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function formatDistanceKm(km) {
  if (km == null || Number.isNaN(km)) return '—';
  if (km < 1) return `${Math.round(km * 1000)} m`;
  return `${km.toFixed(1)} km`;
}
